import { render, staticRenderFns } from "./validateQr.vue?vue&type=template&id=4b85261d&scoped=true"
import script from "./validateQr.vue?vue&type=script&lang=js"
export * from "./validateQr.vue?vue&type=script&lang=js"
import style0 from "./validateQr.vue?vue&type=style&index=0&id=4b85261d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85261d",
  null
  
)

export default component.exports